<template>
  <div class="d-comment-box-guest comment-item grid-flex grid-no-response">
    <div class="grid-item-shrink avatar">
      <img :src="userAvatarUrl">
    </div>

    <div class="grid-item">
      <div
        class="fake-textarea"
        @click="triggerSignUp"
      >
        <span>{{ placeholder }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

import AVATAR_IMG from '@d-assets/avatar.png';

export default {
  props: {
    placeholder: {
      type: String,
      default: 'Write a comment...',
    },
  },
  data: () => ({
    userAvatarUrl: AVATAR_IMG,
  }),
  methods: {
    triggerSignUp() {
      Vue.prototype.signupModal.show();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.d-comment-box-guest {
  border-bottom: $border-width-base solid getColor($grey);
  padding-bottom: ($_2em - $border-width-base);

  .avatar {
    margin-right: $_1em !important;
  }

  .fake-textarea {
    border: $border-width-base solid getColor($grey, medium);
    border-radius: $border-radius-lg;
    box-sizing: border-box;
    color: getColor($grey, dark);
    cursor: pointer;
    display: inline-block;
    height: $_5em;
    line-height: $_5em * 0.5;
    padding: $_1em;
    width: 100%;

    @include transition((
      border-color
    ));

    &:hover {
      border-color: getColor($yellow);
    }
  }
}
</style>
